import { render, staticRenderFns } from "./text.vue?vue&type=template&id=0ae47e06&scoped=true"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"
import style0 from "./text.vue?vue&type=style&index=0&id=0ae47e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae47e06",
  null
  
)

export default component.exports